// This array is used to be able to loop through the template object while ignoring images and certain attributes

export const templateAttributes = [
  "setting",
  "printable",
  "printMode",
  "paperSize",
  "photoRatio",
  "sendGif",
  "columns",
  "theme",
  "category"
];

// This array is used to loop through attributes that will be sent to the backend when submitting a template-based config

export const templateSubmissionAttributes = [
  "eventId",
  "eventName",
  "templateId", // facebook template id
  "pageId",
  "appId",
  "appSecret",
  "facebookToken"
];



// WEBPACK FOOTER //
// ./src/constants/templateAttributes.js